import { PAGE_META } from "@/config/page-meta";
import { CreateCredentialForm } from "@/features/credentials/components/create-credential-form";
import { useCredentialsListParams } from "@/features/credentials/pages/list/hooks/use-credentials-list-params";
import { getCreateCredentialSheetBack } from "@/features/credentials/pages/create/lib/get-create-credential-sheet-back";
import { usePageMeta } from "@/hooks/use-page-meta";
import { RouteSheet } from "@cmde/shadcn";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

export default function CreateCredentialSheetPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { customerId, organizationId, sport } = useCredentialsListParams();

  const closeSheet = () => {
    navigate(getCreateCredentialSheetBack({ customerId, organizationId, sport }));
  };

  return (
    <>
      {usePageMeta(PAGE_META.credentialsCreate)}
      <RouteSheet title={t("credentials.create.title")} size="xl" onClose={closeSheet}>
        <div className="px-6 pb-6">
          <CreateCredentialForm
            sport={sport}
            organizationId={organizationId}
            onCancel={closeSheet}
            onSuccess={closeSheet}
          />
        </div>
      </RouteSheet>
    </>
  );
}
